// extracted by mini-css-extract-plugin
module.exports = {"Table":"BSTable_Table__1FDs5","SelectFilter":"BSTable_SelectFilter__15evH"};